import { getToken, refreshToken } from "./tokenManager";

export const checkAuth = async (): Promise<boolean> => {

  let token = getToken();

  if (!token) return false;

  const newToken = await refreshToken();

  if (!newToken) return false;

  return true;
};